<tec-copy-text [label]="truncateUUID(uuid)" [labelToCopy]="uuid" />
